import { FC, useCallback, useEffect, useState } from "react";
import HighchartsReact from "highcharts-react-official";
import HighCharts from "highcharts";

import { StatisticsObjectType } from "../caseVolumeLineChart/types";
import { BAR_CHART_PATIENT_DIRECT_PURCHASES } from "src/constants/highCharts";

type keys = "DUROLANE" | "GELSYN" | "SUPARTZ FX"

const CustomComponentCasesByDrugsBarCharts: FC<StatisticsObjectType> = ({ StatisticsObjectType }): JSX.Element => {
  const [pdpsbarChartOptionPrior, setPdpsChartOptionsPrior] = useState(BAR_CHART_PATIENT_DIRECT_PURCHASES);

  const populatingDrugChart = useCallback(() => {
    let latestChartOptions = { ...pdpsbarChartOptionPrior };
    latestChartOptions = { ...pdpsbarChartOptionPrior };
    const sorted_keys = Object.keys(StatisticsObjectType.case_by_drug).sort() as keys[]

    latestChartOptions.xAxis = {
      categories: sorted_keys
    }
    latestChartOptions.series = [{
      type: 'bar',
      name: 'value',
      data: StatisticsObjectType && StatisticsObjectType.case_by_drug && sorted_keys.map((item: keys) => StatisticsObjectType.case_by_drug[item] ?? 0),
    }];

    setPdpsChartOptionsPrior(latestChartOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [StatisticsObjectType])

  useEffect(() => {
    populatingDrugChart()
  }, [populatingDrugChart]);


  return (
    <div className="row">
      <div className="col-12 mt-3">
        <div className="card">
          <div className="card-header">
            <h2 className="m-0 text-center text-primary">Cases By Drug
            </h2>
          </div>

          <div className="card-body">
            <HighchartsReact highcharts={HighCharts} options={pdpsbarChartOptionPrior} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomComponentCasesByDrugsBarCharts;
